import { localeNameSpaces, useTranslation } from "@payping/utils/localeUtils";

export function useAppTranslation() {
  return useTranslation(localeNameSpaces[localeNameSpaces.Wrapper]);
}
